import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() { if (this.element.value) this.format() }

  format() {
    const before = this.element.value
    const cursor = this.element.selectionStart || before.length
    const digitsBefore = before.slice(0, cursor).replace(/\D/g, "").length
    let digits = before.replace(/\D/g, "")
    if (before.trim().startsWith("+7") || /^[78]/.test(digits)) digits = digits.slice(1)
    if (before.trim().startsWith("+7") && digits === "7") digits = ""
    digits = digits.slice(0, 10)
    let value = "+7"
    if (digits.length) value += ` (${digits.slice(0, 3)}`
    if (digits.length >= 3) value += ")"
    if (digits.length > 3) value += ` ${digits.slice(3, 6)}`
    if (digits.length > 6) value += `-${digits.slice(6, 8)}`
    if (digits.length > 8) value += `-${digits.slice(8, 10)}`
    this.element.value = value
    let index = value.length
    if (cursor < before.length) {
      let seen = 0
      index = Array.from(value).findIndex(character => {
        if (/\d/.test(character)) seen++
        return seen >= digitsBefore
      }) + 1
    }
    this.element.setSelectionRange(index, index)
    this.validate()
  }

  keydown(event) {
    const cursor = this.element.selectionStart
    if (event.key !== "Backspace" || cursor !== this.element.selectionEnd || cursor <= 3 || /\d/.test(this.element.value[cursor - 1])) return
    event.preventDefault()
    let index = cursor - 1
    while (index > 2 && !/\d/.test(this.element.value[index])) index--
    this.element.value = this.element.value.slice(0, index) + this.element.value.slice(index + 1)
    this.element.setSelectionRange(index, index)
    this.format()
  }

  validate() {
    const digits = this.element.value.replace(/\D/g, "")
    this.element.setCustomValidity(/^7[3489]\d{9}$/.test(digits) ? "" : "Введите российский номер: +7 и 10 цифр.")
  }
}
